import { render, staticRenderFns } from "./buy-popup.vue?vue&type=template&id=b46e7b0e&scoped=true&"
import script from "./buy-popup.vue?vue&type=script&lang=js&"
export * from "./buy-popup.vue?vue&type=script&lang=js&"
import style0 from "./buy-popup.vue?vue&type=style&index=0&id=b46e7b0e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b46e7b0e",
  null
  
)

export default component.exports